import * as ActionTypes from "../../actions";
import status from "./status";

//Updates the status apiCalls data for different api call.
var bankAccountApiCalls = {
  fetchBankAccountsByPersonId: status({
    mapActionToKey: function mapActionToKey(action) {
      return action.personId.toString();
    },
    types: [ActionTypes.GET_BANKACCOUNTSBYPERSONID_REQUEST, ActionTypes.GET_BANKACCOUNTSBYPERSONID_SUCCESS, ActionTypes.GET_BANKACCOUNTSBYPERSONID_FAILURE, ActionTypes.RESET_GET_BANKACCOUNTSBYPERSONID]
  })
};
export default bankAccountApiCalls;